import { formatNumber } from '../number/format';

interface SpinnerOptions {
    maxSteps?: number;
    animationDurationInMS?: number;
}

class NumberSpinner {
    _element: HTMLElement;
    _maxSteps = 40;
    _animationDurationInMS = 200; // ms
    currentValue: number = 0;

    constructor( element: HTMLElement, options: SpinnerOptions = {} ) {
        this._element = element;

        if ( options.maxSteps ) {
            this._maxSteps = options.maxSteps;
        }

        if ( options.animationDurationInMS ) {
            this._animationDurationInMS = options.animationDurationInMS;
        }

        if ( this._element.dataset.from ) {
            this.currentValue = parseInt( this._element.dataset.from as string );
        }
    }

    update( to: number ): void {
        let from = 0;

        if ( this._element.dataset.from ) {
            from = parseInt( this._element.dataset.from as string );
        } else if ( this._element.innerText.length > 0 ) {
            from = parseInt( this._element.innerText );
        }

        if ( from === to ) {
            return;
        }

        this._update( from, to );
    }

    _update( from: number, to: number ): void {
        const difference = to - from;
        const step = Math.ceil( difference / this._maxSteps );

        this.currentValue = to;

        if ( step === 0 ) {
            this._element.dataset.from = to.toString();
            this._element.innerText = formatNumber( to );
            return;
        }

        let current = from;

        const intervalFunc = window.setInterval( () => {
            current += step;

            if ( difference >= 0 && current >= to ) {
                current = to;
                window.clearInterval( intervalFunc );
                this._element.dataset.from = to.toString();
            } else if ( difference <= 0 && current <= to ) {
                current = to;
                window.clearInterval( intervalFunc );
                this._element.dataset.from = to.toString();
            }

            this._element.innerText = formatNumber( current );
        }, this._animationDurationInMS / this._maxSteps );
    }
}

export default NumberSpinner;
